import { SearchFieldOption } from 'components/2-molecules/SearchFieldComponent/SearchFieldComponent';
import { Page } from 'context/PageContext';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { apiInstance } from '../services/Api';
import { FrontendDatasourceEvent, SearchComponent, SearchConfiguration } from './SearchConfiguration';

export class ZipcodeAddressSearch implements SearchComponent {
	searchConfiguration: SearchConfiguration;
	secondarySearchConfiguration: SearchConfiguration;
	apiSearch: boolean;
	isZipcodeSearch: boolean;
	minInputLength: number;
	hasHadResult: boolean;
	searchIcon: string;
	lastValue: string;
	latency: number;
	pageContext: Partial<Page>;

	constructor(searchConfiguration: SearchConfiguration, pageContext: Partial<Page>) {
		this.searchConfiguration = searchConfiguration;
		this.apiSearch = true;
		this.isZipcodeSearch = searchConfiguration.frontendDatasourceEvent === FrontendDatasourceEvent.ZIPCODE;
		this.minInputLength = this.isZipcodeSearch ? 1 : 2;
		this.searchIcon = 'map-pin';
		this.latency = 100;
		this.pageContext = pageContext;

		// marker for adding kvhx field in handleSecondaryChange
		this.secondarySearchConfiguration = {};
	}

	init = async (): Promise<SearchFieldOption[]> => {
		return undefined;
	};

	handleInputChange = async (value: string): Promise<SearchFieldOption[]> => {
		if (value?.trim().length >= this.minInputLength) {
			this.lastValue = value;
			await new Promise((res) => setTimeout(res, this.latency));
			if (this.lastValue !== value) {
				// a new typing overrides this
				return;
			}

			const options: SearchFieldOption[] = [];
			try {
				const res: any = await apiInstance().get(this.searchConfiguration.url + encodeURI(value));

				res?.forEach((element) => {
					this.hasHadResult = true;
					if (this.isZipcodeSearch) {
						options.push({
							label: element.tekst,
							value: element.postnummer?.nr,
						});
					} else {
						options.push({
							label: element.forslagstekst,
							value: JSON.stringify(element.data), //element.data.href,
						});
					}
				});
			} catch (error) {
				console.error(error);
			}
			return options;
		}
		return this.hasHadResult ? [] : undefined;
	};

	handleChange = async (option: SearchFieldOption): Promise<SearchFieldOption> => {
		if (!this.isZipcodeSearch) {
			// add kvh or kvhx from Dataforsyningen to address object
			const data = JSON.parse(option.value);
			if (data.href) {
				const resKvhx: any = await apiInstance().get(data.href);
				if (resKvhx) {
					data.kvhx = resKvhx.kvhx ?? resKvhx.kvh;
					option.value = JSON.stringify(data);
				}
			}
		}
		return option;
	};

	handleSecondaryChange = async (
		option: SearchFieldOption,
		register: UseFormRegister<FieldValues>
	): Promise<void> => {
		if (this.isZipcodeSearch) {
			return; // Dataforsyningen doesn't have kvh(x) on postal codes
		}
		let kvhx;
		try {
			kvhx = JSON.parse(option.value)?.kvhx;
		} catch (error) {
			// perhaps there is not always kvh(x) in Dataforsyningen address search (?)
			console.warn(error);
		}

		if (!kvhx) {
			return;
		}
		const calculatorParameterPrefix = this.pageContext.metaArea?.items[0]?.content?.calculatorParameterPrefix;
		const kvhxName = calculatorParameterPrefix + '_GEO_KVHX';
		const { onChange } = register(kvhxName, { required: true });
		await onChange({
			target: {
				name: kvhxName,
				value: {
					id: kvhxName,
					value: kvhx,
					label: kvhx,
					stepTitle: 'Kvhx',
					type: 'SearchFieldBlock',
				},
			},
		});

		const countryCode = calculatorParameterPrefix + '_COUNTRY_CODE';
		const countryCodeValue = 'DK';
		const { onChange: onChangeCountry } = register(countryCode, { required: true });
		await onChangeCountry({
			target: {
				name: countryCode,
				value: {
					id: countryCode,
					value: countryCodeValue,
					label: countryCodeValue,
					stepTitle: 'Landekode',
					type: 'SearchFieldBlock',
				},
			},
		});
	};
}
